document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cancri-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('.cancri-hero__slide'));
    if (!slides.length) return;
    const interval = Number(hero.dataset.speed) || 5000;
    let current = 0;
    let timer;

    const activate = (index, initial = false) => {
      slides.forEach((slide, i) => {
        slide.classList.remove('is-active', 'is-leaving', 'is-initial');
        if (i === index) {
          slide.classList.add('is-active');
          if (initial) slide.classList.add('is-initial');
        }
      });
    };

    activate(0, true);

    const next = () => {
      const outgoing = slides[current];
      outgoing.classList.remove('is-active', 'is-initial');
      outgoing.classList.add('is-leaving');
      current = (current + 1) % slides.length;
      const incoming = slides[current];
      incoming.classList.remove('is-leaving');
      incoming.classList.add('is-active');
      window.setTimeout(() => outgoing.classList.remove('is-leaving'), 1050);
    };

    if (slides.length > 1) {
      window.setTimeout(() => {
        timer = window.setInterval(next, interval);
      }, 400);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && timer) {
          window.clearInterval(timer);
          timer = null;
        } else if (entry.isIntersecting && !timer && slides.length > 1) {
          timer = window.setInterval(next, interval);
        }
      });
    });
    observer.observe(hero);
  });
});
